var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-progress"},[_c('ul',[_vm._l((_vm.items),function(ref){
var name = ref.name;
var id = ref.id;
var visible = ref.visible;
var depth = ref.depth;
var show = ref.show;
return [(show)?_c('li',{key:id,staticClass:"item",class:[
        {
          visible: visible,
          parent: visible > 1,
        },
        'depth-'+depth
      ],on:{"click":function($event){return _vm.scrollTo(id)}}},[_vm._v("\n      "+_vm._s(name)+"\n    ")]):_vm._e()]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }